import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import ProductHero from "@components/WebsiteRevamp/Heros/ProductHero/ProductHero"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CustomerStories from "@jsons/customerStories.json"
import StudioFeatures from "@jsons/studioFeature.json"
import StudioOverview from "@jsons/studioOverview.json"
import CustomersSection from "@pages/Studio/FeaturesPage/CustomersSection/CustomersSection"
import FeatureSection from "@pages/Studio/FeaturesPage/FeatureSection/FeatureSection"
import FormSection from "@pages/Studio/FeaturesPage/FormSection/FormSection"
import React from "react"

type Props = {}

const features = (props: Props) => {
	const featuresPageDate = getTranslatedPageData(
		StudioFeatures,
		undefined,
		true,
	)
	const list = getValueOrThrow(
		featuresPageDate.AdvancedSideAsset,
		"No Studio Features AdvancedSideAsset",
	)

	const pageDataOverview = getTranslatedPageData(StudioOverview, true)

	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})

	return (
		<>
			<HeadMeta
				meta={featuresPageDate.metaData}
				customPath={"/products/studio/features"}
			/>

			<section>
				<ProductHero
					theme={"studio"}
					data={getValueOrThrow(
						pageDataOverview.heroData?.[0],
						"No Studio Overview AdvancedSideAsset - Features Page",
					)}
				/>
			</section>
			{pageDataOverview.subMenu && (
				<PageSubNavigation withCurve data={pageDataOverview.subMenu} />
			)}
			<FeatureSection
				activeIndex={0}
				cardDirection={"left"}
				data={list[1]}
				direction={"left"}
				linkPanel={getValueOrThrow(
					list[0].mainContent,
					"No Studio Features mainContent list 0",
				)}
			/>

			<FeatureSection
				activeIndex={1}
				cardDirection={"right"}
				data={list[2]}
				direction={"right"}
				linkPanel={getValueOrThrow(
					list[0].mainContent,
					"No Studio Features mainContent list 0",
				)}
			/>

			<FeatureSection
				activeIndex={2}
				cardDirection={"left"}
				data={list[3]}
				direction={"left"}
				linkPanel={getValueOrThrow(
					list[0].mainContent,
					"No Studio Features mainContent list 0",
				)}
			/>
			<FeatureSection
				activeIndex={3}
				cardDirection={"right"}
				data={list[4]}
				direction={"right"}
				linkPanel={getValueOrThrow(
					list[0].mainContent,
					"No Studio Features mainContent list 0",
				)}
			/>
			<FeatureSection
				activeIndex={4}
				cardDirection={"left"}
				data={list[5]}
				direction={"left"}
				linkPanel={getValueOrThrow(
					list[0].mainContent,
					"No Studio Features mainContent list 0",
				)}
			/>

			<CustomersSection data={stories} body={list[6]} />

			<FormSection data={list[7]} />
		</>
	)
}

export default features
